import React, { useContext } from 'react';

import { RM_TAGS } from '../const';

const RmContext = React.createContext({});

export const useRmTag = (tag: RM_TAGS) => {
  const context = useContext(RmContext);

  //@ts-ignore
  context.tag = tag;
};

export default RmContext;
